import React, { Component } from 'react'
import {
  Button,
  Card
} from 'antd'
import { withTranslation } from 'react-i18next'

class CancellationRequests extends Component {
  handleExport = async () => {
    this.props.onExport()
  }

  render () {
    const { t } = this.props
    return (
      <div className='eventDownloadBox no-print'>
        <Card
          title={t('download.cancel')}
          size="small"
          style={{marginBottom: 10}}
          key='CancellationRequests'
        >
          <Button
            onClick={this.handleExport}
            icon="export"
            loading={this.props.exporting}
          >
            {t('download.download')}
          </Button>
        </Card>
      </div>
    )
  }
}

export default withTranslation() (CancellationRequests)
